/**
 * This file was auto-generated by openapi-typescript, extracted by scripts/extract-enums-from-schema.js
 * & enum keys fixed by scripts/fix-enum-keys.js.
 * Do not make direct changes to the file.
 */

export enum PathsV1BranchUuidGetParametersQueryExtend {
    Address = "address",
    Company = "company",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    BrandRelations_Brand = "brandRelations.brand",
    DunningUser = "dunningUser",
    DunningRepresentative = "dunningRepresentative"
}

export enum PathsV1BranchUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Address = "address",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    Company = "company",
    Name = "name",
    Phone = "phone",
    Email = "email",
    DunningUser = "dunningUser",
    DunningRepresentative = "dunningRepresentative",
    AccountingDunningClerkId = "accountingDunningClerkId",
    SignatureTabletEmail = "signatureTabletEmail",
    DeletedAt = "deletedAt"
}

export enum PathsV1BranchUuidGetParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Address = "address",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    Company = "company",
    Name = "name",
    Phone = "phone",
    Email = "email",
    DeletedAt = "deletedAt",
    Distance = "distance"
}

export enum PathsV1BranchUuidGetParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1BranchSearchPostParametersQueryExtend {
    Address = "address",
    Company = "company",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    BrandRelations_Brand = "brandRelations.brand",
    DunningUser = "dunningUser",
    DunningRepresentative = "dunningRepresentative"
}

export enum PathsV1BranchSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Address = "address",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    Company = "company",
    Name = "name",
    Phone = "phone",
    Email = "email",
    DunningUser = "dunningUser",
    DunningRepresentative = "dunningRepresentative",
    AccountingDunningClerkId = "accountingDunningClerkId",
    SignatureTabletEmail = "signatureTabletEmail",
    DeletedAt = "deletedAt"
}

export enum PathsV1BranchSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Address = "address",
    Brands = "brands",
    BranchIdentifiers = "branchIdentifiers",
    BrandRelations = "brandRelations",
    Company = "company",
    Name = "name",
    Phone = "phone",
    Email = "email",
    DeletedAt = "deletedAt",
    Distance = "distance"
}

export enum PathsV1BranchSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1UserUuidGetParametersQueryExtend {
    Address = "address",
    MainBranch = "mainBranch",
    MainBranch_Company = "mainBranch.company",
    MainBranch_Brands = "mainBranch.brands",
    MainBranch_Address = "mainBranch.address",
    Brands = "brands",
    Branches = "branches",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates"
}

export enum PathsV1UserUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier"
}

export enum PathsV1UserSearchPostParametersQueryExtend {
    Address = "address",
    MainBranch = "mainBranch",
    MainBranch_Company = "mainBranch.company",
    MainBranch_Brands = "mainBranch.brands",
    MainBranch_Address = "mainBranch.address",
    Brands = "brands",
    Branches = "branches",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates"
}

export enum PathsV1UserSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier"
}

export enum PathsV1UserSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1UserSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier"
}

export enum PathsV1UserSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1UserUuidAppRoleGetParametersQueryExtend {
    AppRole = "appRole",
    AppRole_AttributeBranch = "appRole.attributeBranch",
    AppRole_AttributeBranch_Address = "appRole.attributeBranch.address",
    AppRole_AttributeCompany = "appRole.attributeCompany",
    AppRole_AttributeCompanyGroup = "appRole.attributeCompanyGroup",
    User = "user"
}

export enum PathsV1UserUuidAppRoleGetParametersQuerySelect {
    AppRole = "appRole",
    User = "user"
}

export enum PathsV1UserUuidAppRoleGetParametersQuerySearchField {
    AppRole_Name = "appRole.name",
    User_FirstName = "user.firstName",
    User_LastName = "user.lastName",
    User_Email = "user.email"
}

export enum PathsV1UserUuidAppRoleGetParametersQueryOrderByField {
    AppRole = "appRole",
    User = "user"
}

export enum PathsV1UserUuidAppRoleGetParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1UserUuidSubordinateGetParametersQueryExtend {
    Address = "address",
    MainBranch = "mainBranch",
    MainBranch_Company = "mainBranch.company",
    MainBranch_Brands = "mainBranch.brands",
    MainBranch_Address = "mainBranch.address",
    Brands = "brands",
    Branches = "branches",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates"
}

export enum PathsV1UserUuidSubordinateGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier"
}

export enum PathsV1UserUuidSubordinateGetParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1UserUuidSubordinateGetParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier",
    Depth = "depth"
}

export enum PathsV1UserUuidSubordinateGetParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1UserUuidSupervisorGetParametersQueryExtend {
    Address = "address",
    MainBranch = "mainBranch",
    MainBranch_Company = "mainBranch.company",
    MainBranch_Brands = "mainBranch.brands",
    MainBranch_Address = "mainBranch.address",
    Brands = "brands",
    Branches = "branches",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates"
}

export enum PathsV1UserUuidSupervisorGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier"
}

export enum PathsV1UserUuidSupervisorGetParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1UserUuidSupervisorGetParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    AzureObjectUuid = "azureObjectUuid",
    EmployeeId = "employeeId",
    Address = "address",
    MainBranch = "mainBranch",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    AppRoles = "appRoles",
    AppRoleHasUser = "appRoleHasUser",
    TemporaryPermissions = "temporaryPermissions",
    UserAbsences = "userAbsences",
    Manager = "manager",
    Subordinates = "subordinates",
    Type = "type",
    Specialization = "specialization",
    SignatureQualifier = "signatureQualifier",
    Depth = "depth"
}

export enum PathsV1UserUuidSupervisorGetParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1ApplicationUuidGetParametersQueryExtend {
    AppRoles = "appRoles"
}

export enum PathsV1ApplicationUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    AzureClientUuid = "azureClientUuid",
    AzureObjectUuid = "azureObjectUuid",
    AzureEnterpriseObjectUuid = "azureEnterpriseObjectUuid",
    Name = "name",
    IsV1Application = "isV1Application",
    AppRoles = "appRoles"
}

export enum PathsV1ApplicationSearchPostParametersQueryExtend {
    AppRoles = "appRoles"
}

export enum PathsV1ApplicationSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    AzureClientUuid = "azureClientUuid",
    AzureObjectUuid = "azureObjectUuid",
    AzureEnterpriseObjectUuid = "azureEnterpriseObjectUuid",
    Name = "name",
    IsV1Application = "isV1Application",
    AppRoles = "appRoles"
}

export enum PathsV1ApplicationSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    AzureClientUuid = "azureClientUuid",
    AzureObjectUuid = "azureObjectUuid",
    AzureEnterpriseObjectUuid = "azureEnterpriseObjectUuid",
    Name = "name",
    IsV1Application = "isV1Application",
    AppRoles = "appRoles"
}

export enum PathsV1ApplicationSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1AppRoleUuidGetParametersQueryExtend {
    Application = "application",
    Users = "users",
    Groups = "groups",
    Attribute = "attribute",
    AttributeBranch = "attributeBranch",
    AttributeBranch_Address = "attributeBranch.address",
    AttributeCompany = "attributeCompany",
    AttributeCompanyGroup = "attributeCompanyGroup",
    AppRoleHasUser = "appRoleHasUser"
}

export enum PathsV1AppRoleUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    AzureObjectUuid = "azureObjectUuid",
    Application = "application",
    Users = "users",
    Groups = "groups",
    Attribute = "attribute",
    AttributeBranch = "attributeBranch",
    AttributeCompany = "attributeCompany",
    AttributeCompanyGroup = "attributeCompanyGroup",
    AppRoleHasUser = "appRoleHasUser"
}

export enum PathsV1AppRoleSearchPostParametersQueryExtend {
    Application = "application",
    Users = "users",
    Groups = "groups",
    Attribute = "attribute",
    AttributeBranch = "attributeBranch",
    AttributeBranch_Address = "attributeBranch.address",
    AttributeCompany = "attributeCompany",
    AttributeCompanyGroup = "attributeCompanyGroup",
    AppRoleHasUser = "appRoleHasUser"
}

export enum PathsV1AppRoleSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    AzureObjectUuid = "azureObjectUuid",
    Application = "application",
    Users = "users",
    Groups = "groups",
    Attribute = "attribute",
    AttributeBranch = "attributeBranch",
    AttributeCompany = "attributeCompany",
    AttributeCompanyGroup = "attributeCompanyGroup",
    AppRoleHasUser = "appRoleHasUser"
}

export enum PathsV1AppRoleSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    AzureObjectUuid = "azureObjectUuid",
    Application = "application",
    Users = "users",
    Groups = "groups",
    Attribute = "attribute",
    AttributeBranch = "attributeBranch",
    AttributeCompany = "attributeCompany",
    AttributeCompanyGroup = "attributeCompanyGroup",
    AppRoleHasUser = "appRoleHasUser"
}

export enum PathsV1AppRoleSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1AppRoleAttributeUuidGetParametersQueryExtend {
    Application = "application"
}

export enum PathsV1AppRoleAttributeUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Application = "application",
    Type = "type"
}

export enum PathsV1AppRoleAttributeSearchPostParametersQueryExtend {
    Application = "application"
}

export enum PathsV1AppRoleAttributeSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Application = "application",
    Type = "type"
}

export enum PathsV1AppRoleAttributeSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Application = "application",
    Type = "type"
}

export enum PathsV1AppRoleAttributeSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1AuditLogSearchPostParametersQueryExtend {
}

export enum PathsV1AuditLogSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    EntityName = "entityName",
    EntityId = "entityId",
    Action = "action",
    Operation = "operation",
    ActorType = "actorType",
    ActorId = "actorId",
    CorrelationId = "correlationId",
    Changes = "changes"
}

export enum PathsV1AuditLogSearchPostParametersQueryOrderByField {
    CreatedAt = "createdAt"
}

export enum PathsV1AuditLogSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1GroupUuidGetParametersQueryExtend {
    Rules = "rules",
    AppRoles = "appRoles"
}

export enum PathsV1GroupUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Rules = "rules",
    AppRoles = "appRoles"
}

export enum PathsV1GroupSearchPostParametersQueryExtend {
    Rules = "rules",
    AppRoles = "appRoles"
}

export enum PathsV1GroupSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Rules = "rules",
    AppRoles = "appRoles"
}

export enum PathsV1GroupSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Rules = "rules",
    AppRoles = "appRoles"
}

export enum PathsV1GroupSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1BrandUuidGetParametersQueryExtend {
    Users = "users",
    Rules = "rules",
    Branches = "branches"
}

export enum PathsV1BrandUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DatId = "datId",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    Type = "type",
    LogoPath = "logoPath",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1BrandSearchPostParametersQueryExtend {
    Users = "users",
    Rules = "rules",
    Branches = "branches"
}

export enum PathsV1BrandSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DatId = "datId",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    Type = "type",
    LogoPath = "logoPath",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1BrandSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DatId = "datId",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    Type = "type",
    LogoPath = "logoPath",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1BrandSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1RuleUuidGetParametersQueryExtend {
    Group = "group",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    CompanyGroups = "companyGroups",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address"
}

export enum PathsV1RuleUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Group = "group",
    DeletedAt = "deletedAt",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    CompanyGroups = "companyGroups",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations"
}

export enum PathsV1RuleSearchPostParametersQueryExtend {
    Group = "group",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    CompanyGroups = "companyGroups",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    Branches_Company = "branches.company",
    Branches_Brands = "branches.brands",
    Branches_Address = "branches.address"
}

export enum PathsV1RuleSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Group = "group",
    DeletedAt = "deletedAt",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    CompanyGroups = "companyGroups",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations"
}

export enum PathsV1RuleSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Group = "group",
    DeletedAt = "deletedAt",
    Brands = "brands",
    Branches = "branches",
    Companies = "companies",
    CompanyGroups = "companyGroups",
    Departments = "departments",
    JobFunctions = "jobFunctions",
    Occupations = "occupations",
    Brands_Name = "brands.name",
    Brands_TechnicalId = "brands.technicalId",
    Branches_Company_Name = "branches.company.name",
    Branches_Address_PostalCode = "branches.address.postalCode",
    Companies_Name = "companies.name",
    CompanyGroups_Name = "companyGroups.name",
    Departments_Name = "departments.name",
    JobFunctions_Name = "jobFunctions.name",
    Occupations_Name = "occupations.name",
    Group_Name = "group.name",
    CompanyDisplay = "companyDisplay",
    CompanyGroupDisplay = "companyGroupDisplay",
    BranchDisplay = "branchDisplay",
    BrandDisplay = "brandDisplay",
    DepartmentDisplay = "departmentDisplay",
    JobFunctionDisplay = "jobFunctionDisplay",
    OccupationDisplay = "occupationDisplay"
}

export enum PathsV1RuleSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CompanyGroupUuidGetParametersQueryExtend {
    Companies = "companies",
    CompanyGroupIdentifiers = "companyGroupIdentifiers"
}

export enum PathsV1CompanyGroupUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Companies = "companies",
    CompanyGroupIdentifiers = "companyGroupIdentifiers"
}

export enum PathsV1CompanyGroupSearchPostParametersQueryExtend {
    Companies = "companies",
    CompanyGroupIdentifiers = "companyGroupIdentifiers"
}

export enum PathsV1CompanyGroupSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Companies = "companies",
    CompanyGroupIdentifiers = "companyGroupIdentifiers"
}

export enum PathsV1CompanyGroupSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    Name = "name",
    TechnicalId = "technicalId",
    CompanyGroupIdentifiers_Identifier = "companyGroupIdentifiers.identifier"
}

export enum PathsV1CompanyGroupSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Companies = "companies",
    CompanyGroupIdentifiers = "companyGroupIdentifiers"
}

export enum PathsV1CompanyGroupSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CompanyUuidGetParametersQueryExtend {
    Users = "users",
    Rules = "rules",
    CompanyIdentifiers = "companyIdentifiers",
    ManagingDirectorOccupations = "managingDirectorOccupations",
    ManagingDirectors = "managingDirectors",
    CompanyGroup = "companyGroup"
}

export enum PathsV1CompanyUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Type = "type",
    CompanyIdentifiers = "companyIdentifiers",
    LogoPath = "logoPath",
    CommercialRegisterCourt = "commercialRegisterCourt",
    CommercialRegisterNumber = "commercialRegisterNumber",
    VatId = "vatId",
    ManagingDirectorOccupations = "managingDirectorOccupations",
    DeletedAt = "deletedAt",
    CompanyGroup = "companyGroup",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1CompanySearchPostParametersQueryExtend {
    Users = "users",
    Rules = "rules",
    CompanyIdentifiers = "companyIdentifiers",
    ManagingDirectorOccupations = "managingDirectorOccupations",
    ManagingDirectors = "managingDirectors",
    CompanyGroup = "companyGroup"
}

export enum PathsV1CompanySearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Type = "type",
    CompanyIdentifiers = "companyIdentifiers",
    LogoPath = "logoPath",
    CommercialRegisterCourt = "commercialRegisterCourt",
    CommercialRegisterNumber = "commercialRegisterNumber",
    VatId = "vatId",
    ManagingDirectorOccupations = "managingDirectorOccupations",
    DeletedAt = "deletedAt",
    CompanyGroup = "companyGroup",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1CompanySearchPostParametersQuerySearchField {
    Uuid = "uuid",
    Name = "name",
    TechnicalId = "technicalId",
    CommercialRegisterCourt = "commercialRegisterCourt",
    CommercialRegisterNumber = "commercialRegisterNumber",
    VatId = "vatId",
    CompanyIdentifiers_Identifier = "companyIdentifiers.identifier"
}

export enum PathsV1CompanySearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    TechnicalId = "technicalId",
    Type = "type",
    CompanyIdentifiers = "companyIdentifiers",
    LogoPath = "logoPath",
    CommercialRegisterCourt = "commercialRegisterCourt",
    CommercialRegisterNumber = "commercialRegisterNumber",
    VatId = "vatId",
    ManagingDirectorOccupations = "managingDirectorOccupations",
    DeletedAt = "deletedAt",
    CompanyGroup = "companyGroup",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1CompanySearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CustomerUuidGetParametersQueryExtend {
    Addresses = "addresses",
    Addresses_Address = "addresses.address",
    CustomerIdentifiers = "customerIdentifiers",
    Companies = "companies",
    Companies_CompanyIdentifiers = "companies.companyIdentifiers",
    Branch = "branch",
    Branch_Address = "branch.address",
    Branch_Company = "branch.company",
    Branch_Company_CompanyIdentifiers = "branch.company.companyIdentifiers",
    Branch_BranchIdentifiers = "branch.branchIdentifiers",
    SapExport = "sapExport"
}

export enum PathsV1CustomerUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    LastName = "lastName",
    Type = "type",
    Gender = "gender",
    FirstName = "firstName",
    CustomerCompanyName = "customerCompanyName",
    BirthDate = "birthDate",
    CountryCode = "countryCode",
    LanguageCode = "languageCode",
    Email = "email",
    Mobile = "mobile",
    Landline = "landline",
    Fax = "fax",
    VatId = "vatId",
    DeletedAt = "deletedAt",
    Companies = "companies",
    Branch = "branch",
    Addresses = "addresses",
    CustomerIdentifiers = "customerIdentifiers",
    SapExport = "sapExport"
}

export enum PathsV1CustomerSearchPostParametersQueryExtend {
    Addresses = "addresses",
    Addresses_Address = "addresses.address",
    CustomerIdentifiers = "customerIdentifiers",
    Companies = "companies",
    Companies_CompanyIdentifiers = "companies.companyIdentifiers",
    Branch = "branch",
    Branch_Address = "branch.address",
    Branch_Company = "branch.company",
    Branch_Company_CompanyIdentifiers = "branch.company.companyIdentifiers",
    Branch_BranchIdentifiers = "branch.branchIdentifiers",
    SapExport = "sapExport"
}

export enum PathsV1CustomerSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    LastName = "lastName",
    Type = "type",
    Gender = "gender",
    FirstName = "firstName",
    CustomerCompanyName = "customerCompanyName",
    BirthDate = "birthDate",
    CountryCode = "countryCode",
    LanguageCode = "languageCode",
    Email = "email",
    Mobile = "mobile",
    Landline = "landline",
    Fax = "fax",
    VatId = "vatId",
    DeletedAt = "deletedAt",
    Companies = "companies",
    Branch = "branch",
    Addresses = "addresses",
    CustomerIdentifiers = "customerIdentifiers",
    SapExport = "sapExport"
}

export enum PathsV1CustomerSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    CustomerCompanyName = "customerCompanyName",
    Email = "email",
    Mobile = "mobile",
    Landline = "landline",
    Fax = "fax",
    VatId = "vatId",
    CustomerIdentifiers_Identifier = "customerIdentifiers.identifier"
}

export enum PathsV1CustomerSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    LastName = "lastName",
    Type = "type",
    Gender = "gender",
    FirstName = "firstName",
    CustomerCompanyName = "customerCompanyName",
    BirthDate = "birthDate",
    CountryCode = "countryCode",
    LanguageCode = "languageCode",
    Email = "email",
    Mobile = "mobile",
    Landline = "landline",
    Fax = "fax",
    VatId = "vatId",
    DeletedAt = "deletedAt",
    Companies = "companies",
    Branch = "branch",
    Addresses = "addresses",
    CustomerIdentifiers = "customerIdentifiers",
    SapExport = "sapExport"
}

export enum PathsV1CustomerSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CustomerSapExportSearchPostParametersQueryExtend {
    Customer = "customer",
    Customer_CustomerIdentifiers = "customer.customerIdentifiers",
    Customer_Addresses = "customer.addresses",
    Customer_Addresses_Address = "customer.addresses.address",
    Customer_Branch = "customer.branch",
    Customer_Branch_Address = "customer.branch.address",
    Customer_Branch_Company = "customer.branch.company",
    Customer_Companies = "customer.companies",
    Customer_Companies_CompanyIdentifiers = "customer.companies.companyIdentifiers"
}

export enum PathsV1CustomerSapExportSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Customer = "customer",
    ExportStatus = "exportStatus",
    CompletionMode = "completionMode",
    LastExportAt = "lastExportAt",
    ErrorCategory = "errorCategory",
    ErrorSapCode = "errorSapCode",
    ErrorHttpStatus = "errorHttpStatus",
    ErrorMessage = "errorMessage",
    ErrorTransactionId = "errorTransactionId"
}

export enum PathsV1CustomerSapExportSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Customer = "customer",
    ExportStatus = "exportStatus",
    CompletionMode = "completionMode",
    LastExportAt = "lastExportAt",
    ErrorCategory = "errorCategory",
    ErrorSapCode = "errorSapCode",
    ErrorHttpStatus = "errorHttpStatus",
    ErrorMessage = "errorMessage",
    ErrorTransactionId = "errorTransactionId",
    CustomerName = "customerName"
}

export enum PathsV1CustomerSapExportSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CustomerSapExportUuidGetParametersQueryExtend {
    Customer = "customer",
    Customer_CustomerIdentifiers = "customer.customerIdentifiers",
    Customer_Addresses = "customer.addresses",
    Customer_Addresses_Address = "customer.addresses.address",
    Customer_Branch = "customer.branch",
    Customer_Branch_Address = "customer.branch.address",
    Customer_Branch_Company = "customer.branch.company",
    Customer_Companies = "customer.companies",
    Customer_Companies_CompanyIdentifiers = "customer.companies.companyIdentifiers"
}

export enum PathsV1CustomerSapExportUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Customer = "customer",
    ExportStatus = "exportStatus",
    CompletionMode = "completionMode",
    LastExportAt = "lastExportAt",
    ErrorCategory = "errorCategory",
    ErrorSapCode = "errorSapCode",
    ErrorHttpStatus = "errorHttpStatus",
    ErrorMessage = "errorMessage",
    ErrorTransactionId = "errorTransactionId"
}

export enum PathsV1DataExportTypesTypeColumnsGetParametersPathType {
    CompanyGroup = "CompanyGroup",
    Company = "Company",
    Branch = "Branch",
    User = "User",
    Vehicle = "Vehicle",
    Customer = "Customer",
    GroupMember = "GroupMember",
    RelocationOrder = "RelocationOrder"
}

export enum PathsV1OpenPositionSearchPostParametersQueryExtend {
    Customer = "customer",
    Customer_CustomerIdentifiers = "customer.customerIdentifiers",
    Company = "company",
    Branch = "branch",
    DunningBlock = "dunningBlock",
    DunningBlockSapSync = "dunningBlockSapSync"
}

export enum PathsV1OpenPositionSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    CompanyCode = "companyCode",
    FiscalYear = "fiscalYear",
    DocumentNumber = "documentNumber",
    InvoiceNumber = "invoiceNumber",
    DocumentItemNumber = "documentItemNumber",
    Type = "type",
    Amount = "amount",
    Currency = "currency",
    DueDate = "dueDate",
    DunningLevel = "dunningLevel",
    DunningBlock = "dunningBlock",
    Customer = "customer",
    Company = "company",
    Branch = "branch"
}

export enum PathsV1OpenPositionSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    CompanyCode = "companyCode",
    FiscalYear = "fiscalYear",
    DocumentNumber = "documentNumber",
    InvoiceNumber = "invoiceNumber",
    DocumentItemNumber = "documentItemNumber",
    Type = "type",
    Amount = "amount",
    Currency = "currency",
    DueDate = "dueDate",
    DunningLevel = "dunningLevel",
    DunningBlock = "dunningBlock",
    Customer = "customer",
    Company = "company",
    Branch = "branch",
    CustomerName = "customerName",
    BranchName = "branchName"
}

export enum PathsV1OpenPositionSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1OpenPositionSearchByCustomerPostParametersQueryExtend {
}

export enum PathsV1OpenPositionSearchByCustomerPostParametersQuerySelect {
}

export enum PathsV1OpenPositionSearchByCustomerPostParametersQueryOrderByField {
    Name = "name",
    InvoiceBalance = "invoiceBalance",
    PaymentBalance = "paymentBalance",
    TotalBalance = "totalBalance",
    PositionCount = "positionCount",
    OverdueAmount = "overdueAmount",
    OldestDueDate = "oldestDueDate",
    MaxDunningLevel = "maxDunningLevel"
}

export enum PathsV1OpenPositionSearchByCustomerPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1OpenPositionSearchByBranchPostParametersQueryExtend {
}

export enum PathsV1OpenPositionSearchByBranchPostParametersQuerySelect {
}

export enum PathsV1OpenPositionSearchByBranchPostParametersQueryOrderByField {
    Name = "name",
    InvoiceBalance = "invoiceBalance",
    PaymentBalance = "paymentBalance",
    TotalBalance = "totalBalance",
    PositionCount = "positionCount",
    OverdueAmount = "overdueAmount",
    OldestDueDate = "oldestDueDate",
    MaxDunningLevel = "maxDunningLevel"
}

export enum PathsV1OpenPositionSearchByBranchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1ElectronicSignatureTemplateConfigurationSearchPostParametersQueryExtend {
    CompanyGroup = "companyGroup"
}

export enum PathsV1ElectronicSignatureTemplateConfigurationSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    CompanyGroup = "companyGroup",
    Provider = "provider",
    DocumentType = "documentType",
    TemplateId = "templateId"
}

export enum PathsV1ElectronicSignatureTemplateConfigurationSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    CompanyGroup = "companyGroup",
    Provider = "provider",
    DocumentType = "documentType",
    TemplateId = "templateId"
}

export enum PathsV1ElectronicSignatureTemplateConfigurationSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1DepartmentUuidGetParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1DepartmentUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1DepartmentSearchPostParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1DepartmentSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1DepartmentSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1DepartmentSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1JobFunctionUuidGetParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1JobFunctionUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1JobFunctionSearchPostParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1JobFunctionSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1JobFunctionSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    V1Id = "v1Id",
    TechnicalId = "technicalId",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1JobFunctionSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1OccupationUuidGetParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1OccupationUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1OccupationSearchPostParametersQueryExtend {
    Users = "users",
    Rules = "rules"
}

export enum PathsV1OccupationSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1OccupationSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    DeletedAt = "deletedAt",
    Users = "users",
    Rules = "rules"
}

export enum PathsV1OccupationSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1TemporaryPermissionUuidGetParametersQueryExtend {
    RequestBy = "request_by",
    RequestFor = "request_for"
}

export enum PathsV1TemporaryPermissionUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Reason = "reason",
    RequestBy = "request_by",
    RequestFor = "request_for",
    Status = "status",
    ValidFrom = "valid_from",
    ValidUntil = "valid_until"
}

export enum PathsV1TemporaryPermissionSearchPostParametersQueryExtend {
    RequestBy = "request_by",
    RequestFor = "request_for"
}

export enum PathsV1TemporaryPermissionSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Reason = "reason",
    RequestBy = "request_by",
    RequestFor = "request_for",
    Status = "status",
    ValidFrom = "valid_from",
    ValidUntil = "valid_until"
}

export enum PathsV1TemporaryPermissionSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Reason = "reason",
    RequestBy = "request_by",
    RequestFor = "request_for",
    Status = "status",
    ValidFrom = "valid_from",
    ValidUntil = "valid_until"
}

export enum PathsV1TemporaryPermissionSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1UserAbsenceUuidGetParametersQueryExtend {
    User = "user"
}

export enum PathsV1UserAbsenceUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    ReasonOfAbsence = "reasonOfAbsence",
    StartTimeOfDay = "startTimeOfDay",
    EndTimeOfDay = "endTimeOfDay",
    DateFrom = "dateFrom",
    DateUntil = "dateUntil",
    User = "user"
}

export enum PathsV1UserAbsenceSearchPostParametersQueryExtend {
    User = "user"
}

export enum PathsV1UserAbsenceSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    ReasonOfAbsence = "reasonOfAbsence",
    StartTimeOfDay = "startTimeOfDay",
    EndTimeOfDay = "endTimeOfDay",
    DateFrom = "dateFrom",
    DateUntil = "dateUntil",
    User = "user"
}

export enum PathsV1UserAbsenceSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    ReasonOfAbsence = "reasonOfAbsence",
    StartTimeOfDay = "startTimeOfDay",
    EndTimeOfDay = "endTimeOfDay",
    DateFrom = "dateFrom",
    DateUntil = "dateUntil",
    User = "user"
}

export enum PathsV1UserAbsenceSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1GroupManualMembershipSearchPostParametersQueryExtend {
    Uuid = "uuid",
    User = "user",
    Group = "group",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt"
}

export enum PathsV1GroupManualMembershipSearchPostParametersQuerySelect {
    Uuid = "uuid",
    User = "user",
    Group = "group",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt"
}

export enum PathsV1GroupManualMembershipSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    User = "user",
    Group = "group",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt"
}

export enum PathsV1GroupManualMembershipSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1GroupManualMembershipUserSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email"
}

export enum PathsV1ModelFamilyUuidGetParametersQueryExtend {
    Brand = "brand",
    ModelGenerations = "modelGenerations",
    ModelGenerations_ModelGenerationIdentifiers = "modelGenerations.modelGenerationIdentifiers",
    ModelFamilyIdentifiers = "modelFamilyIdentifiers"
}

export enum PathsV1ModelFamilyUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    Brand = "brand",
    ModelGenerations = "modelGenerations",
    ModelFamilyIdentifiers = "modelFamilyIdentifiers"
}

export enum PathsV1ModelFamilySearchPostParametersQueryExtend {
    Brand = "brand",
    ModelGenerations = "modelGenerations",
    ModelGenerations_ModelGenerationIdentifiers = "modelGenerations.modelGenerationIdentifiers",
    ModelFamilyIdentifiers = "modelFamilyIdentifiers"
}

export enum PathsV1ModelFamilySearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    Brand = "brand",
    ModelGenerations = "modelGenerations",
    ModelFamilyIdentifiers = "modelFamilyIdentifiers"
}

export enum PathsV1ModelFamilySearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    Brand = "brand",
    ModelGenerations = "modelGenerations",
    ModelFamilyIdentifiers = "modelFamilyIdentifiers",
    DatId = "datId"
}

export enum PathsV1ModelFamilySearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1ModelGenerationUuidGetParametersQueryExtend {
    ModelFamily = "modelFamily",
    ModelFamily_Brand = "modelFamily.brand",
    ModelFamily_ModelFamilyIdentifiers = "modelFamily.modelFamilyIdentifiers",
    Vehicles = "vehicles",
    ModelGenerationIdentifiers = "modelGenerationIdentifiers"
}

export enum PathsV1ModelGenerationUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    VehicleKind = "vehicleKind",
    ModelFamily = "modelFamily",
    Vehicles = "vehicles",
    ModelGenerationIdentifiers = "modelGenerationIdentifiers"
}

export enum PathsV1ModelGenerationSearchPostParametersQueryExtend {
    ModelFamily = "modelFamily",
    ModelFamily_Brand = "modelFamily.brand",
    ModelFamily_ModelFamilyIdentifiers = "modelFamily.modelFamilyIdentifiers",
    Vehicles = "vehicles",
    ModelGenerationIdentifiers = "modelGenerationIdentifiers"
}

export enum PathsV1ModelGenerationSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    VehicleKind = "vehicleKind",
    ModelFamily = "modelFamily",
    Vehicles = "vehicles",
    ModelGenerationIdentifiers = "modelGenerationIdentifiers"
}

export enum PathsV1ModelGenerationSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Name = "name",
    VehicleKind = "vehicleKind",
    ModelFamily = "modelFamily",
    Vehicles = "vehicles",
    ModelGenerationIdentifiers = "modelGenerationIdentifiers",
    BrandName = "brandName",
    DatId = "datId"
}

export enum PathsV1ModelGenerationSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleUuidGetParametersQueryExtend {
    ModelGeneration = "modelGeneration",
    ModelGeneration_ModelFamily = "modelGeneration.modelFamily",
    ModelGeneration_ModelFamily_Brand = "modelGeneration.modelFamily.brand",
    ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "modelGeneration.modelFamily.modelFamilyIdentifiers",
    OwningBranch = "owningBranch",
    OwningBranch_Company = "owningBranch.company",
    OwningBranch_Brands = "owningBranch.brands",
    OwningBranch_Address = "owningBranch.address",
    CurrentBranch = "currentBranch",
    CurrentBranch_Company = "currentBranch.company",
    CurrentBranch_Brands = "currentBranch.brands",
    CurrentBranch_Address = "currentBranch.address",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    VehicleBlock_BlockedBy = "vehicleBlock.blockedBy",
    ExchangeEngine = "exchangeEngine"
}

export enum PathsV1VehicleUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    V1UpdatedAt = "v1UpdatedAt",
    V1SourceTable = "v1SourceTable",
    ModelGeneration = "modelGeneration",
    ModelDescription = "modelDescription",
    Vin = "vin",
    NumberOfHolders = "numberOfHolders",
    Color = "color",
    Drivetrain = "drivetrain",
    RegistrationDate = "registrationDate",
    HuDate = "huDate",
    ServiceHistory = "serviceHistory",
    VehicleUsage = "vehicleUsage",
    RimType = "rimType",
    AccidentState = "accidentState",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    EngineKilowatts = "engineKilowatts",
    EngineDisplacementCcm = "engineDisplacementCcm",
    NumberDoors = "numberDoors",
    Status = "status",
    OwningBranch = "owningBranch",
    CurrentBranch = "currentBranch",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    ExchangeEngine = "exchangeEngine",
    VehicleKind = "vehicleKind"
}

export enum PathsV1VehicleVinVinGetParametersQueryExtend {
    ModelGeneration = "modelGeneration",
    ModelGeneration_ModelFamily = "modelGeneration.modelFamily",
    ModelGeneration_ModelFamily_Brand = "modelGeneration.modelFamily.brand",
    ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "modelGeneration.modelFamily.modelFamilyIdentifiers",
    OwningBranch = "owningBranch",
    OwningBranch_Company = "owningBranch.company",
    OwningBranch_Brands = "owningBranch.brands",
    OwningBranch_Address = "owningBranch.address",
    CurrentBranch = "currentBranch",
    CurrentBranch_Company = "currentBranch.company",
    CurrentBranch_Brands = "currentBranch.brands",
    CurrentBranch_Address = "currentBranch.address",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    VehicleBlock_BlockedBy = "vehicleBlock.blockedBy",
    ExchangeEngine = "exchangeEngine"
}

export enum PathsV1VehicleVinVinGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    V1UpdatedAt = "v1UpdatedAt",
    V1SourceTable = "v1SourceTable",
    ModelGeneration = "modelGeneration",
    ModelDescription = "modelDescription",
    Vin = "vin",
    NumberOfHolders = "numberOfHolders",
    Color = "color",
    Drivetrain = "drivetrain",
    RegistrationDate = "registrationDate",
    HuDate = "huDate",
    ServiceHistory = "serviceHistory",
    VehicleUsage = "vehicleUsage",
    RimType = "rimType",
    AccidentState = "accidentState",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    EngineKilowatts = "engineKilowatts",
    EngineDisplacementCcm = "engineDisplacementCcm",
    NumberDoors = "numberDoors",
    Status = "status",
    OwningBranch = "owningBranch",
    CurrentBranch = "currentBranch",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    ExchangeEngine = "exchangeEngine",
    VehicleKind = "vehicleKind"
}

export enum PathsV1VehicleSearchPostParametersQueryExtend {
    ModelGeneration = "modelGeneration",
    ModelGeneration_ModelFamily = "modelGeneration.modelFamily",
    ModelGeneration_ModelFamily_Brand = "modelGeneration.modelFamily.brand",
    ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "modelGeneration.modelFamily.modelFamilyIdentifiers",
    OwningBranch = "owningBranch",
    OwningBranch_Company = "owningBranch.company",
    OwningBranch_Brands = "owningBranch.brands",
    OwningBranch_Address = "owningBranch.address",
    CurrentBranch = "currentBranch",
    CurrentBranch_Company = "currentBranch.company",
    CurrentBranch_Brands = "currentBranch.brands",
    CurrentBranch_Address = "currentBranch.address",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    VehicleBlock_BlockedBy = "vehicleBlock.blockedBy",
    ExchangeEngine = "exchangeEngine"
}

export enum PathsV1VehicleSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    V1UpdatedAt = "v1UpdatedAt",
    V1SourceTable = "v1SourceTable",
    ModelGeneration = "modelGeneration",
    ModelDescription = "modelDescription",
    Vin = "vin",
    NumberOfHolders = "numberOfHolders",
    Color = "color",
    Drivetrain = "drivetrain",
    RegistrationDate = "registrationDate",
    HuDate = "huDate",
    ServiceHistory = "serviceHistory",
    VehicleUsage = "vehicleUsage",
    RimType = "rimType",
    AccidentState = "accidentState",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    EngineKilowatts = "engineKilowatts",
    EngineDisplacementCcm = "engineDisplacementCcm",
    NumberDoors = "numberDoors",
    Status = "status",
    OwningBranch = "owningBranch",
    CurrentBranch = "currentBranch",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    ExchangeEngine = "exchangeEngine",
    VehicleKind = "vehicleKind"
}

export enum PathsV1VehicleSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    Vin = "vin",
    LicensePlate = "licensePlate",
    ManufacturerColor = "manufacturerColor",
    ModelGeneration_Name = "modelGeneration.name",
    ModelGeneration_ModelFamily_Name = "modelGeneration.modelFamily.name",
    ModelDescription = "modelDescription",
    ModelGeneration_ModelFamily_Brand_Name = "modelGeneration.modelFamily.brand.name",
    OwningBranch_Name = "owningBranch.name",
    OwningBranch_Company_Name = "owningBranch.company.name",
    OwningBranch_Address_City = "owningBranch.address.city",
    CurrentBranch_Name = "currentBranch.name",
    CurrentBranch_Company_Name = "currentBranch.company.name",
    CurrentBranch_Address_City = "currentBranch.address.city"
}

export enum PathsV1VehicleSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    V1UpdatedAt = "v1UpdatedAt",
    V1SourceTable = "v1SourceTable",
    ModelGeneration = "modelGeneration",
    ModelDescription = "modelDescription",
    Vin = "vin",
    NumberOfHolders = "numberOfHolders",
    Color = "color",
    Drivetrain = "drivetrain",
    RegistrationDate = "registrationDate",
    HuDate = "huDate",
    ServiceHistory = "serviceHistory",
    VehicleUsage = "vehicleUsage",
    RimType = "rimType",
    AccidentState = "accidentState",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    EngineKilowatts = "engineKilowatts",
    EngineDisplacementCcm = "engineDisplacementCcm",
    NumberDoors = "numberDoors",
    Status = "status",
    OwningBranch = "owningBranch",
    CurrentBranch = "currentBranch",
    RelocationOrders = "relocationOrders",
    VehicleBlock = "vehicleBlock",
    ExchangeEngine = "exchangeEngine",
    VehicleKind = "vehicleKind",
    ModelGeneration_ModelFamily_Brand = "modelGeneration.modelFamily.brand"
}

export enum PathsV1VehicleSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleBuyInEmployeesSearchPostParametersQueryExtend {
}

export enum PathsV1VehicleBuyInEmployeesSearchPostParametersQuerySelect {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email"
}

export enum PathsV1VehicleBuyInEmployeesSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    EmployeeId = "employeeId",
    Telephone = "telephone",
    Mobile = "mobile"
}

export enum PathsV1VehicleBuyInEmployeesSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email"
}

export enum PathsV1VehicleBuyInEmployeesSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleBuyInSearchPostParametersQueryExtend {
    Vehicle = "vehicle",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    VehicleValuation = "vehicleValuation",
    VehicleValuation_Vehicle = "vehicleValuation.vehicle",
    ElectronicSignature = "electronicSignature",
    CreatedBy = "createdBy",
    Branch = "branch"
}

export enum PathsV1VehicleBuyInSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    VehicleValuation = "vehicleValuation",
    ElectronicSignature = "electronicSignature",
    CreatedBy = "createdBy",
    Branch = "branch",
    Status = "status",
    ErrorMessage = "errorMessage",
    V1TransferAt = "v1TransferAt",
    Type = "type",
    TradeInReference = "tradeInReference",
    TransferDate = "transferDate",
    Price = "price",
    MileageAtBuyIn = "mileageAtBuyIn",
    OtherAgreements = "otherAgreements",
    DocumentSnapshot = "documentSnapshot"
}

export enum PathsV1VehicleBuyInSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    Vehicle_Vin = "vehicle.vin"
}

export enum PathsV1VehicleBuyInSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    VehicleValuation = "vehicleValuation",
    ElectronicSignature = "electronicSignature",
    CreatedBy = "createdBy",
    Branch = "branch",
    Status = "status",
    ErrorMessage = "errorMessage",
    Type = "type",
    TradeInReference = "tradeInReference",
    TransferDate = "transferDate",
    Price = "price",
    MileageAtBuyIn = "mileageAtBuyIn",
    OtherAgreements = "otherAgreements",
    DocumentSnapshot = "documentSnapshot",
    CustomerName = "customerName",
    EmployeeLastName = "employeeLastName",
    EmployeeFirstName = "employeeFirstName",
    BuyInType = "buyInType"
}

export enum PathsV1VehicleBuyInSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleBuyInUuidGetParametersQueryExtend {
    Vehicle = "vehicle",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    VehicleValuation = "vehicleValuation",
    VehicleValuation_Vehicle = "vehicleValuation.vehicle",
    ElectronicSignature = "electronicSignature",
    CreatedBy = "createdBy",
    Branch = "branch"
}

export enum PathsV1VehicleBuyInUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    VehicleValuation = "vehicleValuation",
    ElectronicSignature = "electronicSignature",
    CreatedBy = "createdBy",
    Branch = "branch",
    Status = "status",
    ErrorMessage = "errorMessage",
    V1TransferAt = "v1TransferAt",
    Type = "type",
    TradeInReference = "tradeInReference",
    TransferDate = "transferDate",
    Price = "price",
    MileageAtBuyIn = "mileageAtBuyIn",
    OtherAgreements = "otherAgreements",
    DocumentSnapshot = "documentSnapshot"
}

export enum PathsV1VehicleValuationUuidGetParametersQueryExtend {
    Vehicle = "vehicle",
    Requester = "requester",
    AssignedTo = "assignedTo",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    Vehicle_ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "vehicle.modelGeneration.modelFamily.modelFamilyIdentifiers",
    Vehicle_OwningBranch = "vehicle.owningBranch",
    Vehicle_CurrentBranch = "vehicle.currentBranch",
    ConfirmedBy = "confirmedBy",
    Webscan = "webscan"
}

export enum PathsV1VehicleValuationUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    Requester = "requester",
    Provider = "provider",
    Status = "status",
    RegistrationDateUsed = "registrationDateUsed",
    ValuationDateUsed = "valuationDateUsed",
    VinUsed = "vinUsed",
    DatClaimId = "datClaimId",
    MileageUsed = "mileageUsed",
    ProjectedMileage = "projectedMileage",
    NumberOfHoldersUsed = "numberOfHoldersUsed",
    AccidentState = "accidentState",
    RimType = "rimType",
    LeaseBuyoutAmount = "leaseBuyoutAmount",
    EarlyLeaseTermination = "earlyLeaseTermination",
    EarlyLeaseTerminationAmount = "earlyLeaseTerminationAmount",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    RequesterNote = "requesterNote",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    TradeNet = "tradeNet",
    TradeGross = "tradeGross",
    SalesNet = "salesNet",
    SalesGross = "salesGross",
    MarginNet = "marginNet",
    MarginGross = "marginGross",
    MarginPercentage = "marginPercentage",
    PriceAdjustmentPercentage = "priceAdjustmentPercentage",
    Warranty = "warranty",
    VehiclePreparationCosts = "vehiclePreparationCosts",
    ConfirmedTradeGross = "confirmedTradeGross",
    ConfirmedWarranty = "confirmedWarranty",
    ConfirmedVehiclePreparationCosts = "confirmedVehiclePreparationCosts",
    ConfirmedSalesGross = "confirmedSalesGross",
    ConfirmedMarginGross = "confirmedMarginGross",
    ConfirmedMarginPercentage = "confirmedMarginPercentage",
    Note = "note",
    ConfirmedBy = "confirmedBy",
    AssignedTo = "assignedTo",
    ConfirmedAt = "confirmedAt",
    ValidUntil = "validUntil",
    ValuationType = "valuationType",
    ErrorMessage = "errorMessage",
    ErrorProducer = "errorProducer",
    ErrorCode = "errorCode",
    WarningCode = "warningCode",
    ReportPath = "reportPath"
}

export enum PathsV1VehicleValuationConfirmersSearchPostParametersQueryExtend {
}

export enum PathsV1VehicleValuationConfirmersSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1VehicleValuationConfirmersSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    EmployeeId = "employeeId",
    Telephone = "telephone",
    Mobile = "mobile"
}

export enum PathsV1VehicleValuationConfirmersSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1VehicleValuationConfirmersSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationRequestersSearchPostParametersQueryExtend {
}

export enum PathsV1VehicleValuationRequestersSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1VehicleValuationRequestersSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    EmployeeId = "employeeId",
    Telephone = "telephone",
    Mobile = "mobile"
}

export enum PathsV1VehicleValuationRequestersSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    FirstName = "firstName",
    LastName = "lastName",
    Email = "email",
    Telephone = "telephone",
    Mobile = "mobile",
    EmployeeId = "employeeId"
}

export enum PathsV1VehicleValuationRequestersSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationSearchPostParametersQueryExtend {
    Vehicle = "vehicle",
    Requester = "requester",
    AssignedTo = "assignedTo",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    Vehicle_ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "vehicle.modelGeneration.modelFamily.modelFamilyIdentifiers",
    Vehicle_OwningBranch = "vehicle.owningBranch",
    Vehicle_CurrentBranch = "vehicle.currentBranch",
    ConfirmedBy = "confirmedBy",
    Webscan = "webscan"
}

export enum PathsV1VehicleValuationSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    Requester = "requester",
    Provider = "provider",
    Status = "status",
    RegistrationDateUsed = "registrationDateUsed",
    ValuationDateUsed = "valuationDateUsed",
    VinUsed = "vinUsed",
    DatClaimId = "datClaimId",
    MileageUsed = "mileageUsed",
    ProjectedMileage = "projectedMileage",
    NumberOfHoldersUsed = "numberOfHoldersUsed",
    AccidentState = "accidentState",
    RimType = "rimType",
    LeaseBuyoutAmount = "leaseBuyoutAmount",
    EarlyLeaseTermination = "earlyLeaseTermination",
    EarlyLeaseTerminationAmount = "earlyLeaseTerminationAmount",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    RequesterNote = "requesterNote",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    TradeNet = "tradeNet",
    TradeGross = "tradeGross",
    SalesNet = "salesNet",
    SalesGross = "salesGross",
    MarginNet = "marginNet",
    MarginGross = "marginGross",
    MarginPercentage = "marginPercentage",
    PriceAdjustmentPercentage = "priceAdjustmentPercentage",
    Warranty = "warranty",
    VehiclePreparationCosts = "vehiclePreparationCosts",
    ConfirmedTradeGross = "confirmedTradeGross",
    ConfirmedWarranty = "confirmedWarranty",
    ConfirmedVehiclePreparationCosts = "confirmedVehiclePreparationCosts",
    ConfirmedSalesGross = "confirmedSalesGross",
    ConfirmedMarginGross = "confirmedMarginGross",
    ConfirmedMarginPercentage = "confirmedMarginPercentage",
    Note = "note",
    ConfirmedBy = "confirmedBy",
    AssignedTo = "assignedTo",
    ConfirmedAt = "confirmedAt",
    ValidUntil = "validUntil",
    ValuationType = "valuationType",
    ErrorMessage = "errorMessage",
    ErrorProducer = "errorProducer",
    ErrorCode = "errorCode",
    WarningCode = "warningCode",
    ReportPath = "reportPath"
}

export enum PathsV1VehicleValuationSearchPostParametersQuerySearchField {
    Uuid = "uuid",
    Requester_FirstName = "requester.firstName",
    Requester_LastName = "requester.lastName",
    Requester_Email = "requester.email",
    VinUsed = "vinUsed",
    DatClaimId = "datClaimId",
    Provider = "provider",
    Status = "status",
    Vehicle_Vin = "vehicle.vin",
    Vehicle_ModelGeneration_Name = "vehicle.modelGeneration.name",
    Vehicle_ModelGeneration_ModelFamily_Name = "vehicle.modelGeneration.modelFamily.name",
    Vehicle_ModelGeneration_ModelFamily_Brand_Name = "vehicle.modelGeneration.modelFamily.brand.name"
}

export enum PathsV1VehicleValuationSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    Requester = "requester",
    Provider = "provider",
    Status = "status",
    RegistrationDateUsed = "registrationDateUsed",
    ValuationDateUsed = "valuationDateUsed",
    VinUsed = "vinUsed",
    DatClaimId = "datClaimId",
    MileageUsed = "mileageUsed",
    ProjectedMileage = "projectedMileage",
    NumberOfHoldersUsed = "numberOfHoldersUsed",
    AccidentState = "accidentState",
    RimType = "rimType",
    LeaseBuyoutAmount = "leaseBuyoutAmount",
    EarlyLeaseTermination = "earlyLeaseTermination",
    EarlyLeaseTerminationAmount = "earlyLeaseTerminationAmount",
    AccidentDescription = "accidentDescription",
    AccidentValue = "accidentValue",
    RequesterNote = "requesterNote",
    VatDeductible = "vatDeductible",
    Reimport = "reimport",
    TradeNet = "tradeNet",
    TradeGross = "tradeGross",
    SalesNet = "salesNet",
    SalesGross = "salesGross",
    MarginNet = "marginNet",
    MarginGross = "marginGross",
    MarginPercentage = "marginPercentage",
    PriceAdjustmentPercentage = "priceAdjustmentPercentage",
    Warranty = "warranty",
    VehiclePreparationCosts = "vehiclePreparationCosts",
    ConfirmedTradeGross = "confirmedTradeGross",
    ConfirmedWarranty = "confirmedWarranty",
    ConfirmedVehiclePreparationCosts = "confirmedVehiclePreparationCosts",
    ConfirmedSalesGross = "confirmedSalesGross",
    ConfirmedMarginGross = "confirmedMarginGross",
    ConfirmedMarginPercentage = "confirmedMarginPercentage",
    Note = "note",
    ConfirmedBy = "confirmedBy",
    AssignedTo = "assignedTo",
    ConfirmedAt = "confirmedAt",
    ValidUntil = "validUntil",
    ValuationType = "valuationType",
    ErrorMessage = "errorMessage",
    ErrorProducer = "errorProducer",
    ErrorCode = "errorCode",
    WarningCode = "warningCode",
    ReportPath = "reportPath"
}

export enum PathsV1VehicleValuationSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationCostAdditionUuidGetParametersQueryExtend {
}

export enum PathsV1VehicleValuationCostAdditionUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Key = "key",
    ValueNumber = "valueNumber",
    ValueString = "valueString"
}

export enum PathsV1VehicleValuationCostAdditionSearchPostParametersQueryExtend {
}

export enum PathsV1VehicleValuationCostAdditionSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Key = "key",
    ValueNumber = "valueNumber",
    ValueString = "valueString"
}

export enum PathsV1VehicleValuationCostAdditionSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Key = "key",
    ValueNumber = "valueNumber",
    ValueString = "valueString"
}

export enum PathsV1VehicleValuationCostAdditionSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationCostWarrantyUuidGetParametersQueryExtend {
}

export enum PathsV1VehicleValuationCostWarrantyUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    UpToKilowatts = "upToKilowatts",
    Price = "price"
}

export enum PathsV1VehicleValuationCostWarrantySearchPostParametersQueryExtend {
}

export enum PathsV1VehicleValuationCostWarrantySearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    UpToKilowatts = "upToKilowatts",
    Price = "price"
}

export enum PathsV1VehicleValuationCostWarrantySearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    UpToKilowatts = "upToKilowatts",
    Price = "price"
}

export enum PathsV1VehicleValuationCostWarrantySearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationPriceAdjustmentUuidGetParametersQueryExtend {
    Brand = "brand"
}

export enum PathsV1VehicleValuationPriceAdjustmentUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Brand = "brand",
    AdjustmentPercentage = "adjustmentPercentage"
}

export enum PathsV1VehicleValuationPriceAdjustmentSearchPostParametersQueryExtend {
    Brand = "brand"
}

export enum PathsV1VehicleValuationPriceAdjustmentSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Brand = "brand",
    AdjustmentPercentage = "adjustmentPercentage"
}

export enum PathsV1VehicleValuationPriceAdjustmentSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Brand = "brand",
    AdjustmentPercentage = "adjustmentPercentage"
}

export enum PathsV1VehicleValuationPriceAdjustmentSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleValuationSettingsKeyGetParametersQueryExtend {
}

export enum PathsV1VehicleValuationSettingsKeyGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Key = "key",
    Value = "value"
}

export enum PathsV1VehicleBlockUuidGetParametersQueryExtend {
    Vehicle = "vehicle",
    BlockedBy = "blockedBy"
}

export enum PathsV1VehicleBlockUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    BlockedBy = "blockedBy",
    Reason = "reason",
    BlockedFrom = "blockedFrom",
    BlockedUntil = "blockedUntil"
}

export enum PathsV1VehicleBlockSearchPostParametersQueryExtend {
    Vehicle = "vehicle",
    BlockedBy = "blockedBy"
}

export enum PathsV1VehicleBlockSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    BlockedBy = "blockedBy",
    Reason = "reason",
    BlockedFrom = "blockedFrom",
    BlockedUntil = "blockedUntil"
}

export enum PathsV1VehicleBlockSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    BlockedBy = "blockedBy",
    Reason = "reason",
    BlockedFrom = "blockedFrom",
    BlockedUntil = "blockedUntil"
}

export enum PathsV1VehicleBlockSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1VehicleExchangeEngineUuidGetParametersQueryExtend {
    Vehicle = "vehicle"
}

export enum PathsV1VehicleExchangeEngineUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    ExchangeDate = "exchangeDate",
    EngineMileageAtExchange = "engineMileageAtExchange",
    VehicleMileageAtExchange = "vehicleMileageAtExchange",
    Notes = "notes"
}

export enum PathsV1VehicleExchangeEngineSearchPostParametersQueryExtend {
    Vehicle = "vehicle"
}

export enum PathsV1VehicleExchangeEngineSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    ExchangeDate = "exchangeDate",
    EngineMileageAtExchange = "engineMileageAtExchange",
    VehicleMileageAtExchange = "vehicleMileageAtExchange",
    Notes = "notes"
}

export enum PathsV1VehicleExchangeEngineSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    ExchangeDate = "exchangeDate",
    EngineMileageAtExchange = "engineMileageAtExchange",
    VehicleMileageAtExchange = "vehicleMileageAtExchange",
    Notes = "notes"
}

export enum PathsV1VehicleExchangeEngineSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1RelocationOrderUuidGetParametersQueryExtend {
    Vehicle = "vehicle",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    Vehicle_ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "vehicle.modelGeneration.modelFamily.modelFamilyIdentifiers",
    Vehicle_OwningBranch = "vehicle.owningBranch",
    Vehicle_OwningBranch_Company = "vehicle.owningBranch.company",
    Vehicle_OwningBranch_Brands = "vehicle.owningBranch.brands",
    Vehicle_OwningBranch_Address = "vehicle.owningBranch.address",
    Vehicle_CurrentBranch = "vehicle.currentBranch",
    Vehicle_CurrentBranch_Company = "vehicle.currentBranch.company",
    Vehicle_CurrentBranch_Brands = "vehicle.currentBranch.brands",
    Vehicle_CurrentBranch_Address = "vehicle.currentBranch.address",
    Vehicle_VehicleBlock = "vehicle.vehicleBlock",
    Vehicle_VehicleBlock_BlockedBy = "vehicle.vehicleBlock.blockedBy",
    OriginBranch = "originBranch",
    OriginBranch_Company = "originBranch.company",
    OriginBranch_Brands = "originBranch.brands",
    OriginBranch_Address = "originBranch.address",
    OriginAddress = "originAddress",
    CurrentBranch = "currentBranch",
    CurrentBranch_Address = "currentBranch.address",
    DestinationBranch = "destinationBranch",
    DestinationBranch_Company = "destinationBranch.company",
    DestinationBranch_Brands = "destinationBranch.brands",
    DestinationBranch_Address = "destinationBranch.address",
    DestinationAddress = "destinationAddress",
    CurrentAddress = "currentAddress",
    PickedUpBy = "pickedUpBy",
    TransportCompany = "transportCompany",
    OrderedBy = "orderedBy"
}

export enum PathsV1RelocationOrderUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    OriginBranch = "originBranch",
    OriginAddress = "originAddress",
    CurrentBranch = "currentBranch",
    CurrentAddress = "currentAddress",
    DestinationBranch = "destinationBranch",
    DestinationAddress = "destinationAddress",
    EarliestPickupDate = "earliestPickupDate",
    TransportMethod = "transportMethod",
    Status = "status",
    TransportReason = "transportReason",
    PickedUpBy = "pickedUpBy",
    TransportCompany = "transportCompany",
    ResolveNote = "resolveNote",
    OrderedBy = "orderedBy"
}

export enum PathsV1RelocationOrderSearchPostParametersQueryExtend {
    Vehicle = "vehicle",
    Vehicle_ModelGeneration = "vehicle.modelGeneration",
    Vehicle_ModelGeneration_ModelFamily = "vehicle.modelGeneration.modelFamily",
    Vehicle_ModelGeneration_ModelFamily_Brand = "vehicle.modelGeneration.modelFamily.brand",
    Vehicle_ModelGeneration_ModelFamily_ModelFamilyIdentifiers = "vehicle.modelGeneration.modelFamily.modelFamilyIdentifiers",
    Vehicle_OwningBranch = "vehicle.owningBranch",
    Vehicle_OwningBranch_Company = "vehicle.owningBranch.company",
    Vehicle_OwningBranch_Brands = "vehicle.owningBranch.brands",
    Vehicle_OwningBranch_Address = "vehicle.owningBranch.address",
    Vehicle_CurrentBranch = "vehicle.currentBranch",
    Vehicle_CurrentBranch_Company = "vehicle.currentBranch.company",
    Vehicle_CurrentBranch_Brands = "vehicle.currentBranch.brands",
    Vehicle_CurrentBranch_Address = "vehicle.currentBranch.address",
    Vehicle_VehicleBlock = "vehicle.vehicleBlock",
    Vehicle_VehicleBlock_BlockedBy = "vehicle.vehicleBlock.blockedBy",
    OriginBranch = "originBranch",
    OriginBranch_Company = "originBranch.company",
    OriginBranch_Brands = "originBranch.brands",
    OriginBranch_Address = "originBranch.address",
    OriginAddress = "originAddress",
    CurrentBranch = "currentBranch",
    CurrentBranch_Address = "currentBranch.address",
    DestinationBranch = "destinationBranch",
    DestinationBranch_Company = "destinationBranch.company",
    DestinationBranch_Brands = "destinationBranch.brands",
    DestinationBranch_Address = "destinationBranch.address",
    DestinationAddress = "destinationAddress",
    CurrentAddress = "currentAddress",
    PickedUpBy = "pickedUpBy",
    TransportCompany = "transportCompany",
    OrderedBy = "orderedBy"
}

export enum PathsV1RelocationOrderSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    OriginBranch = "originBranch",
    OriginAddress = "originAddress",
    CurrentBranch = "currentBranch",
    CurrentAddress = "currentAddress",
    DestinationBranch = "destinationBranch",
    DestinationAddress = "destinationAddress",
    EarliestPickupDate = "earliestPickupDate",
    TransportMethod = "transportMethod",
    Status = "status",
    TransportReason = "transportReason",
    PickedUpBy = "pickedUpBy",
    TransportCompany = "transportCompany",
    ResolveNote = "resolveNote",
    OrderedBy = "orderedBy"
}

export enum PathsV1RelocationOrderSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Vehicle = "vehicle",
    OriginBranch = "originBranch",
    OriginAddress = "originAddress",
    CurrentBranch = "currentBranch",
    CurrentAddress = "currentAddress",
    DestinationBranch = "destinationBranch",
    DestinationAddress = "destinationAddress",
    EarliestPickupDate = "earliestPickupDate",
    TransportMethod = "transportMethod",
    Status = "status",
    TransportReason = "transportReason",
    PickedUpBy = "pickedUpBy",
    TransportCompany = "transportCompany",
    ResolveNote = "resolveNote",
    OrderedBy = "orderedBy"
}

export enum PathsV1RelocationOrderSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1FitSettingsGetParametersQueryExtend {
}

export enum PathsV1FitSettingsGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    BcaCompany = "bcaCompany"
}

export enum PathsV1CasaviContactWhitelistUuidGetParametersQueryExtend {
}

export enum PathsV1CasaviContactWhitelistUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactWhitelistSearchPostParametersQueryExtend {
}

export enum PathsV1CasaviContactWhitelistSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactWhitelistSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactWhitelistSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CasaviContactBlacklistUuidGetParametersQueryExtend {
}

export enum PathsV1CasaviContactBlacklistUuidGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactBlacklistSearchPostParametersQueryExtend {
}

export enum PathsV1CasaviContactBlacklistSearchPostParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactBlacklistSearchPostParametersQueryOrderByField {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    Element = "element",
    Type = "type",
    CaseSensitive = "caseSensitive",
    Value = "value"
}

export enum PathsV1CasaviContactBlacklistSearchPostParametersQueryOrderByDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum PathsV1CasaviSettingsGetParametersQueryExtend {
}

export enum PathsV1CasaviSettingsGetParametersQuerySelect {
    Uuid = "uuid",
    CreatedAt = "createdAt",
    UpdatedAt = "updatedAt",
    RunOnStartup = "runOnStartup",
    DryRun = "dryRun",
    CronEnabled = "cronEnabled",
    CronSchedule = "cronSchedule",
    Application = "application"
}

export enum BranchIdentifierSystem {
    Formel1Ahg = "FORMEL_1_AHG",
    Formel1Ghg = "FORMEL_1_GHG",
    CROSS = "CROSS",
    FAHRSCHULE = "FAHRSCHULE",
    CARANO = "CARANO",
    Sap = "SAP",
    V1 = "V1"
}

export enum UserStatus {
    Enabled = "Enabled",
    Disabled = "Disabled"
}

export enum UserType {
    Employee = "Employee",
    Guest = "Guest"
}

export enum VehicleKind {
    UNKNOWN = "UNKNOWN",
    MotorVehicle = "MotorVehicle",
    CommercialVehicle = "CommercialVehicle",
    Motorcycle = "Motorcycle",
    Truck = "Truck"
}

export enum BrandType {
    FranchisedOem = "Franchised_Oem",
    NonFranchisedOem = "Non_Franchised_Oem",
    Owned = "Owned",
    Other = "Other"
}

export enum ApplicationV1Enum {
    IsV1 = "Is_V1",
    IsNotV1 = "Is_Not_V1"
}

export enum AppRoleAttributeType {
    Branch = "Branch",
    Company = "Company",
    CompanyGroup = "CompanyGroup"
}

export enum CompanyType {
    Alphartis = "Alphartis",
    Transport = "Transport",
    Supplier = "Supplier"
}

export enum CompanyIdentifierSystem {
    Sap = "SAP",
    V1 = "V1"
}

export enum CompanyGroupIdentifierSystem {
    PAPERLESS = "PAPERLESS"
}

export enum ModelFamilyIdentifierProvider {
    Dat = "DAT"
}

export enum ModelGenerationIdentifierProvider {
    Dat = "DAT"
}

export enum VehicleColor {
    Beige = "Beige",
    Blue = "Blue",
    Brown = "Brown",
    Yellow = "Yellow",
    Gold = "Gold",
    Green = "Green",
    Gray = "Gray",
    Orange = "Orange",
    Red = "Red",
    Black = "Black",
    Silver = "Silver",
    White = "White",
    Purple = "Purple",
    UNKNOWN = "UNKNOWN"
}

export enum VehiclePaintType {
    Solid = "Solid",
    Pearl = "Pearl",
    Metallic = "Metallic",
    Matte = "Matte",
    Chameleon = "Chameleon",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleDrivetrain {
    FrontWheelDrive = "FrontWheelDrive",
    RearWheelDrive = "RearWheelDrive",
    FourWheelDrive = "FourWheelDrive",
    UNKNOWN = "UNKNOWN"
}

export enum ServiceHistoryStatus {
    UNKNOWN = "UNKNOWN",
    NONE = "NONE",
    PARTIAL = "PARTIAL",
    FullServiceHistory = "FULL_SERVICE_HISTORY",
    FullDealerServiceHistory = "FULL_DEALER_SERVICE_HISTORY"
}

export enum VehicleUsage {
    RegularPersonalCommercial = "REGULAR_PERSONAL_COMMERCIAL",
    RENTAL = "RENTAL",
    TaxiRideHailing = "TAXI_RIDE_HAILING",
    DrivingSchool = "DRIVING_SCHOOL",
    DEMO = "DEMO",
    FleetPool = "FLEET_POOL",
    DeliveryCourier = "DELIVERY_COURIER",
    SpecialPurpose = "SPECIAL_PURPOSE",
    CONSTRUCTION = "CONSTRUCTION",
    ManagementCompanyCar = "MANAGEMENT_COMPANY_CAR",
    EmployeeCompanyCar = "EMPLOYEE_COMPANY_CAR",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleValuationRimType {
    OriginalRims = "OriginalRims",
    NonOriginalRims = "NonOriginalRims"
}

export enum VehicleAccidentState {
    AccidentFree = "Accident_Free",
    ExistingDamage = "Existing_Damage",
    RepairedDamage = "Repaired_Damage",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleStatus {
    Incoming = "Incoming",
    InStock = "InStock",
    Sold = "Sold",
    Historic = "Historic",
    ZGMAdmin = "ZGMAdmin",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleV1SourceTable {
    AhgGewa = "AhgGewa",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleBlockReason {
    Maintenance = "Maintenance"
}

export enum VehicleValuationProvider {
    Dat = "DAT"
}

export enum VehicleFuelType {
    Gasoline = "Gasoline",
    Diesel = "Diesel",
    Lpg = "Lpg",
    NaturalGas = "NaturalGas",
    Electric = "Electric",
    HybridGasoline = "HybridGasoline",
    HybridDiesel = "HybridDiesel",
    Hydrogen = "Hydrogen",
    Ethanol = "Ethanol",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleType {
    Sedan = "Sedan",
    StationWagon = "StationWagon",
    VanMinibus = "VanMinibus",
    SuvPickup = "SuvPickup",
    CityCar = "CityCar",
    ConvertibleRoadster = "ConvertibleRoadster",
    SportsCarCoupe = "SportsCarCoupe",
    OtherPassengerCar = "OtherPassengerCar",
    ChopperCruiser = "ChopperCruiser",
    DirtBike = "DirtBike",
    EnduroAdventure = "EnduroAdventure",
    SidecarCombination = "SidecarCombination",
    LightMotorcycle = "LightMotorcycle",
    MopedMokick = "MopedMokick",
    Motorcycle = "Motorcycle",
    NakedBike = "NakedBike",
    PocketBike = "PocketBike",
    Quad = "Quad",
    RallyeCross = "RallyeCross",
    Racing = "Racing",
    RollerScooter = "RollerScooter",
    Scooter = "Scooter",
    SportSuperSport = "SportSuperSport",
    Sporttourer = "Sporttourer",
    Streetfighter = "Streetfighter",
    SuperMoto = "SuperMoto",
    Tourer = "Tourer",
    Trike = "Trike",
    OtherMotorcycles = "OtherMotorcycles",
    TowTruck = "TowTruck",
    CarTransporter = "CarTransporter",
    ThreeWayTipper = "ThreeWayTipper",
    ChassisUpTo7p5Tons = "ChassisUpTo7p5Tons",
    PanelVan = "PanelVan",
    PanelVanHighRoof = "PanelVanHighRoof",
    PanelVanHighRoofLong = "PanelVanHighRoofLong",
    PanelVanLong = "PanelVanLong",
    BoxTruckUpTo7p5Tons = "BoxTruckUpTo7p5Tons",
    MinibusUpTo9Seats = "MinibusUpTo9Seats",
    FlatbedUpTo7p5Tons = "FlatbedUpTo7p5Tons",
    FlatbedTarpaulinUpTo7p5Tons = "FlatbedTarpaulinUpTo7p5Tons",
    AnimalTransport = "AnimalTransport",
    OtherTransportTruckUpTo7p5Tons = "OtherTransportTruckUpTo7p5Tons",
    OtherTrailer = "OtherTrailer",
    UNKNOWN = "UNKNOWN"
}

export enum RelocationOrderTransportMethod {
    OwnAxle = "Own_Axle",
    TransportCompany = "Transport_Company"
}

export enum RelocationOrderStatus {
    TransportCompanyAwaitingPickupDate = "Transport_Company_Awaiting_Pickup_Date",
    TransportCompanyAwaitingReadyForTransport = "Transport_Company_Awaiting_Ready_For_Transport",
    BranchAwaitingPickup = "Branch_Awaiting_Pickup",
    TransportCompanyInTransit = "Transport_Company_In_Transit",
    TransportCompanyRestAtLayover = "Transport_Company_Rest_At_Layover",
    TransportCompanyAwaitingDeliveryAcceptance = "Transport_Company_Awaiting_Delivery_Acceptance",
    Completed = "Completed",
    Cancelled = "Cancelled",
    TransportCompanyRejectedDamagedVehicle = "Transport_Company_Rejected_Damaged_Vehicle",
    TransportCompanyRejectedMissingKeys = "Transport_Company_Rejected_Missing_Keys",
    TransportCompanyRejectedMissingVehicle = "Transport_Company_Rejected_Missing_Vehicle",
    BranchRejectedDamagedVehicle = "Branch_Rejected_Damaged_Vehicle",
    BranchRejectedMissingKeys = "Branch_Rejected_Missing_Keys",
    BranchRejectedMissingVehicle = "Branch_Rejected_Missing_Vehicle",
    BranchRejectedWrongVehicle = "Branch_Rejected_Wrong_Vehicle"
}

export enum RelocationOrderTransportReason {
    Sold = "Sold",
    TestDrive = "Test_Drive",
    ChangeOfLocation = "Change_Of_Location",
    Repair = "Repair",
    DemonstrationVehicleRegistration = "Demonstration_Vehicle_Registration",
    ChangeOfLocationZgm = "Change_Of_Location_ZGM",
    Delivery = "Delivery",
    Bca = "BCA"
}

export enum CustomerGender {
    Male = "Male",
    Female = "Female",
    Diverse = "Diverse",
    Unknown = "Unknown"
}

export enum CustomerType {
    Private = "Private",
    Business = "Business",
    Unknown = "Unknown"
}

export enum DmsSystem {
    Formel1Ahg = "FORMEL_1_AHG",
    Formel1Ghg = "FORMEL_1_GHG",
    CrossBusinessPartnerNumber = "CROSS_BUSINESS_PARTNER_NUMBER",
    CrossAccountingNumber = "CROSS_ACCOUNTING_NUMBER",
    FAHRSCHULE = "FAHRSCHULE",
    CaranoDebitorNr = "CARANO_DEBITOR_NR",
    CaranoGpartnerId = "CARANO_GPARTNER_ID",
    Sap = "SAP",
    Eva = "EVA",
    Rsp = "RSP",
    AlphartisInternal = "ALPHARTIS_INTERNAL",
    ProfessionalWorks = "PROFESSIONAL_WORKS"
}

export enum SapExportStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED"
}

export enum SapExportCompletionMode {
    FULL = "FULL",
    MinimalFallback = "MINIMAL_FALLBACK",
    UpdateMismatch = "UPDATE_MISMATCH"
}

export enum CustomerAddressType {
    Billing = "Billing",
    Delivery = "Delivery",
    Other = "Other"
}

export enum TemporaryPermissionStatus {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected"
}

export enum ReasonOfAbsence {
    Vacation = "Vacation"
}

export enum DayPortion {
    FullDay = "Full_Day",
    Morning = "Morning",
    Afternoon = "Afternoon"
}

export enum NotificationChannelType {
    Email = "Email",
    Sse = "Sse",
    WebPush = "WebPush"
}

export enum NotificationDeliveryStatus {
    Sent = "Sent",
    Failed = "Failed"
}

export enum ApplicationWithAppRolesIsV1Application {
    IsV1 = "Is_V1",
    IsNotV1 = "Is_Not_V1"
}

export enum SubordinateType {
    Direct = "Direct",
    All = "All"
}

export enum AuditLogAction {
    Create = "Create",
    Update = "Update",
    Delete = "Delete"
}

export enum AuditLogActorType {
    User = "User",
    Application = "Application",
    System = "System"
}

export enum AuditLogEntityName {
    OpenPosition = "OpenPosition",
    RelocationOrder = "RelocationOrder"
}

export enum DataExportLimit {
    MaxRows = 100000
}

export enum DataExportType {
    CompanyGroup = "CompanyGroup",
    Company = "Company",
    Branch = "Branch",
    User = "User",
    Vehicle = "Vehicle",
    Customer = "Customer",
    GroupMember = "GroupMember",
    RelocationOrder = "RelocationOrder"
}

export enum OpenPositionType {
    Invoice = "Invoice",
    Payment = "Payment"
}

export enum SapDunningBlockingReasonCode {
    A = "A",
    B = "B",
    D = "D",
    E = "E",
    F = "F",
    G = "G",
    I = "I",
    K = "K",
    M = "M",
    R = "R",
    V = "V",
    Z = "Z",
    Cleared = ""
}

export enum SapDunningBlockSyncStatus {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED"
}

export enum DunningBlockReason {
    Disputed = "Disputed",
    Complaint = "Complaint",
    DebtorClarification = "DebtorClarification",
    Export = "Export",
    FinancedVehicles = "FinancedVehicles",
    Warranty = "Warranty",
    Collection = "Collection",
    InsuranceClaimLawsuit = "InsuranceClaimLawsuit",
    DownPaymentReceived = "DownPaymentReceived",
    Lawyer = "Lawyer",
    Insurance = "Insurance",
    PaymentAgreement = "PaymentAgreement"
}

export enum OpenPositionAgingBucket {
    NotDue = "NotDue",
    Days0To15 = "Days0To15",
    Days16To30 = "Days16To30",
    Days31To60 = "Days31To60",
    Days61To90 = "Days61To90",
    Days91To120 = "Days91To120",
    Days121To180 = "Days121To180",
    Days180Plus = "Days180Plus"
}

export enum PaperlessWebhookEvent {
    DocumentUpdated = "document.updated",
    SubmissionCompleted = "submission.completed",
    SubmissionDeclined = "submission.declined"
}

export enum ElectronicSignatureProvider {
    Paperless = "Paperless"
}

export enum ElectronicSignatureDocumentType {
    VehicleBuyInContract = "Vehicle_Buy_In_Contract"
}

export enum VehicleSearchBodyColor {
    Beige = "Beige",
    Blue = "Blue",
    Brown = "Brown",
    Yellow = "Yellow",
    Gold = "Gold",
    Green = "Green",
    Gray = "Gray",
    Orange = "Orange",
    Red = "Red",
    Black = "Black",
    Silver = "Silver",
    White = "White",
    Purple = "Purple",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleSearchBodyFuelType {
    Gasoline = "Gasoline",
    Diesel = "Diesel",
    Lpg = "Lpg",
    NaturalGas = "NaturalGas",
    Electric = "Electric",
    HybridGasoline = "HybridGasoline",
    HybridDiesel = "HybridDiesel",
    Hydrogen = "Hydrogen",
    Ethanol = "Ethanol",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleSearchBodyVehicleType {
    Sedan = "Sedan",
    StationWagon = "StationWagon",
    VanMinibus = "VanMinibus",
    SuvPickup = "SuvPickup",
    CityCar = "CityCar",
    ConvertibleRoadster = "ConvertibleRoadster",
    SportsCarCoupe = "SportsCarCoupe",
    OtherPassengerCar = "OtherPassengerCar",
    ChopperCruiser = "ChopperCruiser",
    DirtBike = "DirtBike",
    EnduroAdventure = "EnduroAdventure",
    SidecarCombination = "SidecarCombination",
    LightMotorcycle = "LightMotorcycle",
    MopedMokick = "MopedMokick",
    Motorcycle = "Motorcycle",
    NakedBike = "NakedBike",
    PocketBike = "PocketBike",
    Quad = "Quad",
    RallyeCross = "RallyeCross",
    Racing = "Racing",
    RollerScooter = "RollerScooter",
    Scooter = "Scooter",
    SportSuperSport = "SportSuperSport",
    Sporttourer = "Sporttourer",
    Streetfighter = "Streetfighter",
    SuperMoto = "SuperMoto",
    Tourer = "Tourer",
    Trike = "Trike",
    OtherMotorcycles = "OtherMotorcycles",
    TowTruck = "TowTruck",
    CarTransporter = "CarTransporter",
    ThreeWayTipper = "ThreeWayTipper",
    ChassisUpTo7p5Tons = "ChassisUpTo7p5Tons",
    PanelVan = "PanelVan",
    PanelVanHighRoof = "PanelVanHighRoof",
    PanelVanHighRoofLong = "PanelVanHighRoofLong",
    PanelVanLong = "PanelVanLong",
    BoxTruckUpTo7p5Tons = "BoxTruckUpTo7p5Tons",
    MinibusUpTo9Seats = "MinibusUpTo9Seats",
    FlatbedUpTo7p5Tons = "FlatbedUpTo7p5Tons",
    FlatbedTarpaulinUpTo7p5Tons = "FlatbedTarpaulinUpTo7p5Tons",
    AnimalTransport = "AnimalTransport",
    OtherTransportTruckUpTo7p5Tons = "OtherTransportTruckUpTo7p5Tons",
    OtherTrailer = "OtherTrailer",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleSearchBodyVehicleKind {
    UNKNOWN = "UNKNOWN",
    MotorVehicle = "MotorVehicle",
    CommercialVehicle = "CommercialVehicle",
    Motorcycle = "Motorcycle",
    Truck = "Truck"
}

export enum VehicleBuyInSignatureDevice {
    Customer = "customer",
    Company = "company"
}

export enum VehicleBuyInType {
    TradeIn = "TradeIn",
    Purchase = "Purchase"
}

export enum VehicleValuationStatus {
    Failed = "Failed",
    OverhaulNeeded = "OverhaulNeeded",
    VehicleSelectionRequired = "VehicleSelectionRequired",
    WaitingForConfirmation = "WaitingForConfirmation",
    InProgress = "InProgress",
    Confirmed = "Confirmed"
}

export enum VehicleValuationType {
    Default = "Default",
    LeasingBuyout = "LeasingBuyout",
    WholesaleBuyer = "WholesaleBuyer"
}

export enum VehicleValuationErrorProducer {
    Dat = "DAT",
    Aws = "AWS",
    Alphartis = "Alphartis"
}

export enum VehicleValuationErrorCode {
    DatBrandMappingMissing = "DAT_BRAND_MAPPING_MISSING",
    DatBrandMappingMissingNoMasterdataAdmin = "DAT_BRAND_MAPPING_MISSING_NO_MASTERDATA_ADMIN",
    DatBrandMappingMissingNotificationFailed = "DAT_BRAND_MAPPING_MISSING_NOTIFICATION_FAILED"
}

export enum VehicleValuationWarningCode {
    DatVinBasic = "DAT_VIN_BASIC"
}

export enum ElectronicSignatureStatus {
    CreatePending = "CreatePending",
    CreateRequested = "CreateRequested",
    Created = "Created",
    CreateFailed = "CreateFailed",
    SendPending = "SendPending",
    SendRequested = "SendRequested",
    Sent = "Sent",
    SendFailed = "SendFailed",
    CancelPending = "CancelPending",
    CancelRequested = "CancelRequested",
    Cancelled = "Cancelled",
    CancelFailed = "CancelFailed",
    Completed = "Completed",
    Declined = "Declined",
    Expired = "Expired"
}

export enum VehicleBuyInStatus {
    Unknown = "Unknown",
    CreatingContract = "CreatingContract",
    ContractCreated = "ContractCreated",
    SendingContract = "SendingContract",
    ContractSent = "ContractSent",
    CancellingContract = "CancellingContract",
    ContractCancellationFailed = "ContractCancellationFailed",
    ContractCompleted = "ContractCompleted",
    Completed = "Completed",
    V1SyncFailed = "V1SyncFailed",
    Failed = "Failed",
    ContractDeclined = "ContractDeclined",
    ContractCancelled = "ContractCancelled",
    ContractExpired = "ContractExpired"
}

export enum VehicleBuyInConfigurationErrorCode {
    PaperlessWorkspaceIdMissing = "PAPERLESS_WORKSPACE_ID_MISSING",
    PaperlessWorkspaceIdInvalid = "PAPERLESS_WORKSPACE_ID_INVALID",
    PaperlessTemplateIdMissing = "PAPERLESS_TEMPLATE_ID_MISSING",
    PaperlessTemplateIdInvalid = "PAPERLESS_TEMPLATE_ID_INVALID"
}

export enum DatVehicleValuationErrorCode {
    InitialRegistrationToMarketIndex = "INITIAL_REGISTRATION_TO_MARKET_INDEX",
    InvalidVin = "INVALID_VIN",
    InvalidDatEcode = "INVALID_DAT_ECODE",
    DailyVinRequestLimitReached = "DAILY_VIN_REQUEST_LIMIT_REACHED"
}

export enum VehicleValuationTestCaseSelection {
    Success = "success",
    Failures = "failures",
    Both = "both"
}

export enum VehicleValuationTestCaseType {
    Success = "success",
    Failure = "failure"
}

export enum VehicleValuationTestResultStatus {
    Created = "created",
    Rejected = "rejected"
}

export enum VehicleValuationValidity {
    Valid = "Valid",
    Invalid = "Invalid"
}

export enum VehicleValuationSearchBodyFuelType {
    Gasoline = "Gasoline",
    Diesel = "Diesel",
    Lpg = "Lpg",
    NaturalGas = "NaturalGas",
    Electric = "Electric",
    HybridGasoline = "HybridGasoline",
    HybridDiesel = "HybridDiesel",
    Hydrogen = "Hydrogen",
    Ethanol = "Ethanol",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleValuationSearchBodyVehicleType {
    Sedan = "Sedan",
    StationWagon = "StationWagon",
    VanMinibus = "VanMinibus",
    SuvPickup = "SuvPickup",
    CityCar = "CityCar",
    ConvertibleRoadster = "ConvertibleRoadster",
    SportsCarCoupe = "SportsCarCoupe",
    OtherPassengerCar = "OtherPassengerCar",
    ChopperCruiser = "ChopperCruiser",
    DirtBike = "DirtBike",
    EnduroAdventure = "EnduroAdventure",
    SidecarCombination = "SidecarCombination",
    LightMotorcycle = "LightMotorcycle",
    MopedMokick = "MopedMokick",
    Motorcycle = "Motorcycle",
    NakedBike = "NakedBike",
    PocketBike = "PocketBike",
    Quad = "Quad",
    RallyeCross = "RallyeCross",
    Racing = "Racing",
    RollerScooter = "RollerScooter",
    Scooter = "Scooter",
    SportSuperSport = "SportSuperSport",
    Sporttourer = "Sporttourer",
    Streetfighter = "Streetfighter",
    SuperMoto = "SuperMoto",
    Tourer = "Tourer",
    Trike = "Trike",
    OtherMotorcycles = "OtherMotorcycles",
    TowTruck = "TowTruck",
    CarTransporter = "CarTransporter",
    ThreeWayTipper = "ThreeWayTipper",
    ChassisUpTo7p5Tons = "ChassisUpTo7p5Tons",
    PanelVan = "PanelVan",
    PanelVanHighRoof = "PanelVanHighRoof",
    PanelVanHighRoofLong = "PanelVanHighRoofLong",
    PanelVanLong = "PanelVanLong",
    BoxTruckUpTo7p5Tons = "BoxTruckUpTo7p5Tons",
    MinibusUpTo9Seats = "MinibusUpTo9Seats",
    FlatbedUpTo7p5Tons = "FlatbedUpTo7p5Tons",
    FlatbedTarpaulinUpTo7p5Tons = "FlatbedTarpaulinUpTo7p5Tons",
    AnimalTransport = "AnimalTransport",
    OtherTransportTruckUpTo7p5Tons = "OtherTransportTruckUpTo7p5Tons",
    OtherTrailer = "OtherTrailer",
    UNKNOWN = "UNKNOWN"
}

export enum VehicleValuationV1GewaSyncStatus {
    Queued = "Queued"
}

export enum VehicleValuationSettingKey {
    DefaultPriceAdjustmentPercentage = "DefaultPriceAdjustmentPercentage",
    ValidityDays = "ValidityDays"
}

export enum TransportCompanyLoadCapacityExceededErrorCode {
    FitTransportCompanyLoadCapacityExceeded = "FIT_TRANSPORT_COMPANY_LOAD_CAPACITY_EXCEEDED"
}

export enum RelocationOrderTransportCompanyRejectStatus {
    TransportCompanyRejectedDamagedVehicle = "Transport_Company_Rejected_Damaged_Vehicle",
    TransportCompanyRejectedMissingKeys = "Transport_Company_Rejected_Missing_Keys",
    TransportCompanyRejectedMissingVehicle = "Transport_Company_Rejected_Missing_Vehicle"
}

export enum RelocationOrderBranchRejectStatus {
    BranchRejectedDamagedVehicle = "Branch_Rejected_Damaged_Vehicle",
    BranchRejectedMissingKeys = "Branch_Rejected_Missing_Keys",
    BranchRejectedMissingVehicle = "Branch_Rejected_Missing_Vehicle",
    BranchRejectedWrongVehicle = "Branch_Rejected_Wrong_Vehicle"
}

export enum RelocationOrderAlreadyOpenErrorCode {
    FitRelocationOrderAlreadyOpen = "FIT_RELOCATION_ORDER_ALREADY_OPEN"
}

export enum CasaviFilterElement {
    Id = "Id",
    Email = "Email",
    FirstName = "First_Name",
    LastName = "Last_Name",
    CompanyName = "Company_Name"
}

export enum CasaviFilterType {
    Regex = "Regex",
    Contains = "Contains",
    Full = "Full"
}

export enum MergeEntityName {
    Brand = "Brand",
    ModelFamily = "ModelFamily",
    ModelGeneration = "ModelGeneration"
}

export enum MergeFieldCategory {
    Attribute = "Attribute",
    Identifier = "Identifier"
}

export enum MergeRelationType {
    OneToOne = "OneToOne",
    OneToMany = "OneToMany",
    ManyToOne = "ManyToOne",
    ManyToMany = "ManyToMany",
    PivotManyToMany = "PivotManyToMany"
}

export enum MergeConflictType {
    Unknown = "Unknown",
    DuplicateChild = "DuplicateChild",
    UniqueRelation = "UniqueRelation",
    DuplicatePivotRelation = "DuplicatePivotRelation"
}

export enum SubjectRoles {
    Int = "INT",
    Ext = "EXT",
    Developer = "Developer",
    AbsenceAdministrator = "Absence.Administrator",
    MasterdataAdministrator = "Masterdata.Administrator",
    CasaviAdministrator = "Casavi.Administrator",
    RamAdministrator = "RAM.Administrator",
    RamTemporaryPermissionAdministrator = "RAM.TemporaryPermission.Administrator",
    FitIntModerator = "FIT.INT.Moderator",
    FitExtAdministrator = "FIT.EXT.Administrator",
    FitExtHauler = "FIT.EXT.Hauler",
    FabVehicleValuationAdministrator = "FAB.VehicleValuation.Administrator",
    FabVehicleValuationApprover = "FAB.VehicleValuation.Approver",
    FabVehicleValuationUser = "FAB.VehicleValuation.User",
    FabVehicleBuyInUser = "FAB.VehicleBuyIn.User",
    AceUser = "ACE.User",
    FiaUser = "FIA.User"
}

export enum Action {
    Manage = "manage",
    Merge = "merge",
    Create = "create",
    Read = "read",
    Update = "update",
    Delete = "delete"
}

export enum QueueMessageService {
    Api = "api",
    ElectronicSignature = "ElectronicSignature",
    Dat = "DAT",
    SapCommunication = "SapCommunication",
    CustomerImport = "CustomerImport"
}

export enum DatQueueSchemaVersion {
    Value1 = 1
}

export enum DatRequestOrigin {
    AUTOMATED = "AUTOMATED",
    MANUAL = "MANUAL"
}

export enum DatVinRequestQueueDtoServiceName {
    Dat = "DAT"
}

export enum DatVinRequestQueueDtoMessageType {
    VinRequest = "VIN_REQUEST"
}

export enum DatValuationRequestQueueDtoServiceName {
    Dat = "DAT"
}

export enum DatValuationRequestQueueDtoMessageType {
    VALUATION = "VALUATION"
}

export enum DatVinSuccessResponseQueueDtoServiceName {
    Dat = "DAT"
}

export enum DatVinSuccessResponseQueueDtoMessageType {
    VinRequest = "VIN_REQUEST"
}

export enum DatVinSuccessResponseQueueDtoStatus {
    SUCCESS = "SUCCESS"
}

export enum DatValuationSuccessResponseQueueDtoServiceName {
    Dat = "DAT"
}

export enum DatValuationSuccessResponseQueueDtoMessageType {
    VALUATION = "VALUATION"
}

export enum DatValuationSuccessResponseQueueDtoStatus {
    SUCCESS = "SUCCESS"
}

export enum DatQueueResponseMessageType {
    VALUATION = "VALUATION",
    VinRequest = "VIN_REQUEST",
    UNKNOWN = "UNKNOWN"
}

export enum DatErrorResponseQueueDtoServiceName {
    Dat = "DAT"
}

export enum DatErrorResponseQueueDtoStatus {
    ERROR = "ERROR"
}

export enum MergeSelection {
    Source = "Source",
    Target = "Target"
}

export enum V1CommunicationAction {
    SqlQuery = "sql_query",
    Upsert = "upsert",
    UserRightsSync = "user_rights_sync",
    RelocationOrderCreated = "relocation_order_created",
    RelocationOrderCompleted = "relocation_order_completed"
}

export enum V1CommunicationPayloadType {
    Generic = "generic",
    Vehicle = "vehicle",
    VehicleValuation = "vehicle_valuation",
    VehicleBuyIn = "vehicle_buy_in"
}

export enum V1UpsertConditionOperator {
    Eq = "eq",
    Neq = "neq",
    Lt = "lt",
    Lte = "lte",
    Gt = "gt",
    Gte = "gte",
    In = "in",
    IsNull = "is_null",
    IsNotNull = "is_not_null",
    CaseInsensitiveEq = "case_insensitive_eq"
}

export enum V1UpsertConditionGroupOperator {
    And = "and",
    Or = "or"
}

export enum V1UpsertOrderDirection {
    Asc = "asc",
    Desc = "desc"
}

export enum V1UpsertNoMatchAction {
    Insert = "insert",
    Skip = "skip",
    Error = "error"
}

export enum V1UpsertMatchAction {
    UpdateFirst = "update_first",
    UpdateLast = "update_last",
    UpdateAll = "update_all",
    Skip = "skip",
    Error = "error"
}

export enum CustomerExportRequestDtoSchemaVersion {
    Value1 = 1
}

export enum CustomerExportRequestDtoOperation {
    CustomerExport = "CustomerExport"
}

export enum CustomerExportResponseDtoSchemaVersion {
    Value1 = 1
}

export enum CustomerExportResponseDtoOperation {
    CustomerExport = "CustomerExport"
}

export enum CustomerImportRequestDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionFetchRequestService {
    Api = "api"
}

export enum OpenPositionFetchRequestDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionFetchRequestDtoOperation {
    OpenPositionFetch = "OpenPositionFetch"
}

export enum OpenPositionDebitCreditCode {
    S = "S",
    H = "H"
}

export enum SapDunningBlockReason {
    A = "A",
    B = "B",
    D = "D",
    E = "E",
    F = "F",
    G = "G",
    I = "I",
    K = "K",
    M = "M",
    R = "R",
    V = "V",
    Z = "Z"
}

export enum OpenPositionFetchResponseService {
    SapCommunication = "SapCommunication"
}

export enum OpenPositionFetchResponseDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionFetchResponseDtoOperation {
    OpenPositionFetch = "OpenPositionFetch"
}

export enum OpenPositionFullSyncRequestService {
    Api = "api"
}

export enum OpenPositionFullSyncRequestDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionFullSyncRequestDtoOperation {
    ResetOpenPositionPointer = "ResetOpenPositionPointer"
}

export enum OpenPositionDunningBlockUpdateRequestDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionDunningBlockUpdateRequestDtoOperation {
    OpenPositionDunningBlockUpdate = "OpenPositionDunningBlockUpdate"
}

export enum SapDunningBlockUpdateStatus {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED"
}

export enum OpenPositionDunningBlockUpdateResponseDtoSchemaVersion {
    Value1 = 1
}

export enum OpenPositionDunningBlockUpdateResponseDtoOperation {
    OpenPositionDunningBlockUpdate = "OpenPositionDunningBlockUpdate"
}

export enum ElectronicSignatureAction {
    Create = "Create",
    Send = "Send",
    Cancel = "Cancel",
    RefreshStatus = "RefreshStatus"
}

export enum ElectronicSignatureResponseStatus {
    Succeeded = "Succeeded",
    Failed = "Failed"
}

export enum PaperlessSigningProviderDtoType {
    Paperless = "Paperless"
}

export enum VehicleBuyInContractPreparedDocumentDtoType {
    VehicleBuyInContract = "Vehicle_Buy_In_Contract"
}

export enum SigningParticipantRole {
    Customer = "Customer",
    Employee = "Employee"
}

export enum PaperlessDocumentState {
    Draft = "draft",
    Dispatched = "dispatched",
    Completed = "completed",
    Cancelled = "cancelled",
    Declined = "declined",
    Expired = "expired"
}